<template>
  <TransitionGroup name="slide-down" tag="ul" class="px-5 py-3 md:py-8">
    <FeedCard v-for="item in itemsToDisplay" :item="item" :key="`event-${item.id}`" />
  </TransitionGroup>
  <Transition name="slide-down">
    <button v-if="items.length !== itemsToDisplay.length" class="button mx-auto mb-12" @click="seeMore">
      {{ $t('see_more') }}
    </button>
  </Transition>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {FeedCard} from '@/components/cards'

export default {
  name: 'EventList',
  components: {FeedCard},
  data() {
    return {
      count_itemsToDisplay: 3,
    }
  },
  props: {
    items: {
      type: Array as PropType<Event[] | News[]>,
      required: true,
    },
  },
  computed: {
    itemsToDisplay(): (Event | News)[] {
      return this.items.slice(0, this.count_itemsToDisplay)
    },
  },
  methods: {
    seeMore() {
      this.count_itemsToDisplay += 10
    },
  },
}
</script>
